module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAASCAYAAACnxdXaAAAAt0lEQVRIibXV2xHCIBBG4V87oAVboAV7shZrMSXYQlqwheODZCYXAruAZ4YHMpn94AkBAiLwAELaj14hzY+AFvDDr/cf4JDmkpwoYGbbSHgNLs1XSZO2RUkvSUF9hTQn7r5Py4meHOu5ce6GJEfrH0fBRXCPjoCrYA7tgU3gGdoCm8ES6oFdYA21wG7QgpbgWwtoRc/gXFXQg1pgE+hFS7AZbEFzsAtsRdewGwR0AVpfkbuOL5SpL1Px+TGJARuIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/themes/arrowDown.png
// module id = ./src/themes/arrowDown.png
// module chunks = 35783957827783